import { RootState } from "../../../store";
import { AccountsInterface } from "../../accountsSlice";

export const accountsStateSelector = (state: RootState): AccountsInterface =>
  state.accounts;
